"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlCollectionToArray = function (collection) {
    var result = [];
    for (var i = 0; i < collection.length; i++) {
        var item = collection.item(i);
        if (item) {
            result.push(item);
        }
    }
    return result;
};
//# sourceMappingURL=html-collection-to-array.js.map